// ** I18n Imports
import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { sessionConfig } from 'utils/constant';

const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

const storedLang = window.localStorage.getItem(sessionConfig.lang);

const lang = isJsonString(storedLang) ? JSON.parse(storedLang) : storedLang;

const lang_item = lang ? lang : 'tc';

i18n

  // Enables the i18next backend
  .use(Backend)

  // Enable automatic language detection
  .use(new LanguageDetector(null, { lookupLocalStorage: sessionConfig.lang }))

  // Enables the hook initialization module
  .use(initReactI18next)
  .init({
    lng: lang_item,
    backend: {
      /* translation file path */
      loadPath: `${process.env.REACT_APP_BASENAME}/assets/data/locales/{{lng}}.json?v=2.5`
      // loadPath: `/assets/data/locales/{{lng}}.json?v=2.4`
    },
    // fallbackLng: lang_item,
    keySeparator: false,
    react: {
      useSuspense: true
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    detection: {
      lookupLocalStorage: sessionConfig.lang
    }
  });

export default i18n;
